import { render } from "./CardBox.vue?vue&type=template&id=5b684b9a&scoped=true"
import script from "./CardBox.vue?vue&type=script&lang=js"
export * from "./CardBox.vue?vue&type=script&lang=js"

import "./CardBox.vue?vue&type=style&index=0&id=5b684b9a&lang=scss&scoped=true"
import "./CardBox.vue?vue&type=style&index=1&id=5b684b9a&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b684b9a"]])

export default __exports__